import { Injectable } from '@angular/core';
import { ENDPOINTS } from '../constants/endpoints.constant';
import { AjaxService } from './ajax.service';
import { AttendanceService } from './attendance.service';
import { SatisfactionSurveyAnswerInterface } from '../interfaces/satisfaction-survey-answer.interface';
import { SatisfactionSurveyQuestionsResponseInterface } from '../interfaces/satisfaction-survey-questions-response.interface';
import { SendSatisfactionSurveyRequestBodyInterface } from '../interfaces/send-satisfaction-survey-request-body.interface';

@Injectable({
  providedIn: 'root'
})
export class SatisfactionSurveyService {
  constructor(private ajaxService: AjaxService, private attendanceService: AttendanceService) {}

  public async getSatisfactionSurveyQuestions(userAccessToken: string) {
    const response = await this.ajaxService.get<SatisfactionSurveyQuestionsResponseInterface>(
      `${ENDPOINTS.satisfactionSurveyQuestions.url}/${this.attendanceService.attendanceProtocol}`,
      false,
      {
        Authorization_lc: `Bearer ${userAccessToken}`
      }
    );

    return response && response.questoes;
  }
  
  public async getSatisfactionSurveyQuestionsHash(userAccessToken: string, hash: string) {
    const response = await this.ajaxService.get<SatisfactionSurveyQuestionsResponseInterface>(
      `${ENDPOINTS.satisfactionSurveyQuestions.url}/${hash}`,
      false,
      {
        Authorization: `Bearer ${userAccessToken}`
      }
    );
    
    return response;
  }

  public sendSatisfactionSurveyAnswers(answers: SatisfactionSurveyAnswerInterface[]) {
    const attendanceId = this.attendanceService.attendanceId;

    const body: SendSatisfactionSurveyRequestBodyInterface = {
      atendimentoId: attendanceId,
      respostas: answers
    };

    return this.ajaxService.post<void>(ENDPOINTS.sendSatisfactionSurveyAnswers.url, body);
  }
  
  public sendSatisfactionSurveyAnswersHash(attendanceId: number, answers: SatisfactionSurveyAnswerInterface[]) {

    const body: SendSatisfactionSurveyRequestBodyInterface = {
      atendimentoId: attendanceId,
      respostas: answers
    };

    return this.ajaxService.post<void>(ENDPOINTS.sendSatisfactionSurveyAnswers.url, body);
  }
}
